import { useMutation } from '@tanstack/react-query';
import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import { requestEarlyAccessRegistrationToken } from '../api/earlyAccessRegistrationTokenApi';

/**
 * TanStack Query mutation hook to request an Early Access registration token
 * from the Okta Services Gateway.
 *
 * Sample usage:
 * const { mutate, isPending, isError, isSuccess } = useEarlyAccessRegistrationToken();
 * mutate({
 *   orgRefId: 'a1b2c3',
 *   pid: '92028248',
 *   orgType: 'DISTRICT',
 *   countryCode: 'US',
 *   email: 'teacher@example.com',
 * });
 *
 * @returns {Object} Mutation state and methods (mutate, mutateAsync, isPending, isError, isSuccess, error)
 */
const useEarlyAccessRegistrationToken = () =>
  useMutation({
    mutationFn: requestEarlyAccessRegistrationToken,
    onError: (error, variables) => {
      logErrorWithContext(
        'Login app - Error requesting early-access registration token',
        [
          { key: 'errorMessage', value: error?.message },
          { key: 'orgRefId', value: variables?.orgRefId },
        ],
      );
    },
  });

export default useEarlyAccessRegistrationToken;
